import {
  HOME_CATEGORY_FILTERS,
  HOME_CATEGORY_ROUTES,
} from '../components/home/category-filter/filters';

export type NavItem = {
  to: string;
  labelKey: string;
  icon: string;
  end?: boolean;
  /** 상세·하위 경로에서도 active 유지 */
  matchPrefix?: string;
  /** 이 항목 위에 구분선 (공지·선물하기 구역 등) */
  dividerBefore?: boolean;
  /** 홈 하위 — 상황별 맞춤 6종 2뎁스 */
  hasHomeSubNav?: boolean;
};

/** 홈 2뎁스 — 상황별 맞춤 사운드필 6종 */
export const NAV_HOME_SCENARIO_ITEMS: NavItem[] = HOME_CATEGORY_FILTERS.map((filter) => ({
  to: HOME_CATEGORY_ROUTES[filter.id],
  labelKey: filter.labelKey,
  icon: filter.icon,
  matchPrefix: HOME_CATEGORY_ROUTES[filter.id],
}));

/** @deprecated NAV_HOME_SCENARIO_ITEMS 사용 */
export const NAV_SCENARIO_ITEMS = NAV_HOME_SCENARIO_ITEMS;

export function isHomeNavSection(pathname: string): boolean {
  return (
    pathname === '/app/home' ||
    pathname.startsWith('/app/home/') ||
    pathname.startsWith('/app/category/')
  );
}

export const NAV_ITEMS: NavItem[] = [
  {
    to: '/app/home',
    labelKey: 'navigator.home',
    icon: 'home',
    hasHomeSubNav: true,
  },
  {
    to: '/app/playlists',
    labelKey: 'navigator.playlists',
    icon: 'library_music',
    matchPrefix: '/app/playlists',
  },
  {
    to: '/app/analysis',
    labelKey: 'navigator.analysis',
    icon: 'analytics',
    matchPrefix: '/app/analysis',
  },
  { to: '/app/profile', labelKey: 'navigator.profile', icon: 'person' },
  { to: '/app/setting', labelKey: 'navigator.setting', icon: 'settings', end: true },
  {
    to: '/app/notice',
    labelKey: 'navigator.notices',
    icon: 'campaign',
    dividerBefore: true,
    matchPrefix: '/app/notice',
  },
  { to: '/app/gift', labelKey: 'navigator.gift', icon: 'redeem', matchPrefix: '/app/gift' },
];
